import { silenceErrorAlert } from 'conversations-error-reporting/error-actions/builders/silenceErrorAlert';
import { createAction } from 'redux-actions';
import { FILE_UPLOAD_FAILED } from '../constants/actionTypes';
export const fileUploadFailed = createAction(FILE_UPLOAD_FAILED, ({
  fileUpload,
  error
}) => ({
  fileUpload,
  error
}), silenceErrorAlert);